export default {"src":"/_next/static/media/logo.aa92db56.svg","height":40,"width":173,"blurWidth":0,"blurHeight":0};